import React from 'react';
import { CircleDollarSign } from 'lucide-react';

const linePrice = (it) => Number(it?.config?.total_price ?? it?.total_price ?? it?.total ?? it?.price ?? 0);
const nyDay = (d) => {
  const [y, m, day] = new Date(d).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }).split('-').map(Number);
  return Date.UTC(y, m - 1, day);
};

// Visual-only: quotes created from a configurator Quote Request whose total or any line is still $0.
export const needsPricing = (q) => Boolean(q?.quote_request_id) && q.quote_channel === 'configurator'
  && (!(Number(q.total) > 0) || !(q.items || []).length || (q.items || []).some((it) => !(linePrice(it) > 0)));

// Whole New York calendar days since the Sales Quote was created.
export const pricingAgeDays = (q) => (q?.created_at ? Math.max(0, Math.round((nyDay(Date.now()) - nyDay(q.created_at)) / 86400000)) : null);

export const NeedsPricingBadge = ({ quote, testId }) => {
  if (!needsPricing(quote)) return null;
  const days = pricingAgeDays(quote);
  const old = days > 3;
  return (
    <span className={`px-2 py-0.5 text-xs rounded-full font-medium border inline-flex items-center gap-1 ${old ? 'bg-red-100 text-red-800 border-red-300 ring-1 ring-red-200' : 'bg-orange-100 text-orange-800 border-orange-200'}`}
      data-testid={testId || `needs-pricing-${quote.id}`} data-overdue={old ? 'true' : 'false'}>
      <CircleDollarSign className="w-3 h-3" /> Needs pricing{days != null && <> · {days === 0 ? 'today' : `${days} day${days === 1 ? '' : 's'}`}</>}
    </span>
  );
};
